const state = {
  homepage: [],
  get_article: [],
  homepage_id: [],
};

export default state;
